import { Paper, Typography, Divider, Box, Button, Tooltip, TextField, InputAdornment, CircularProgress } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import RefreshIcon from "@mui/icons-material/Refresh";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useState } from "react";

export default function EvolutionChartSection({ onFiltrar, onLimpar, disableActions }) {
  const [skuInput, setSkuInput] = useState('');
  const handleSearchClick = () => {
    // Passa o valor do input para a função de filtro, se tiver conteúdo
    if (skuInput && skuInput.trim() !== '') {
      onFiltrar(skuInput.trim());
    }
  };

  const handleClearClick = () => {
    setSkuInput('');
    onLimpar();
  };

  return (
    <Paper elevation={2} sx={{ p: { xs: 2, md: 3 }, minHeight: 350, border: "1px solid #e0e0e0", borderRadius: 2, background: '#f9faff', mb: 2 }}>
      <Box sx={{ 
        display: 'flex', 
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: { xs: 'stretch', md: 'center' }, 
        justifyContent: 'space-between', 
        mb: 2, 
        gap: 2 
      }}>
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 600, color: '#1a237e', display: 'flex', alignItems: 'center', gap: 1 }}>
            Evolução de Vendas por Produto
            <Tooltip title="Visualize dados históricos de vendas para análise de tendências">
              <HelpOutlineIcon fontSize="small" color="info" sx={{ opacity: 0.7 }} />
            </Tooltip>
          </Typography>
          <Typography variant="body2" sx={{ color: '#607d8b', mt: 0.5 }}>
            Visualize a evolução mensal de vendas, receita e pedidos. Utilize os filtros para analisar SKUs específicos.
          </Typography>
        </Box>

        <Box sx={{ 
          display: 'flex', 
          flexDirection: { xs: 'column', sm: 'row' }, 
          gap: 1,
          width: { xs: '100%', md: 'auto' },
        }}>
          <TextField
            placeholder="Código SKU..."
            size="small"
            fullWidth
            value={skuInput}              onChange={(e) => setSkuInput(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter' && skuInput.trim() !== '') handleSearchClick(); }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
            sx={{ 
              flexGrow: 1,
              minWidth: { xs: '100%', sm: '220px' },
              background: '#f3f3f3',
              borderRadius: 1
            }}
          />

          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={handleSearchClick}
              disabled={disableActions || !skuInput}              startIcon={disableActions ? <CircularProgress size={18} color="inherit" /> : <FilterListIcon />}
              sx={{ 
                flexShrink: 0,
                height: 40,
                borderRadius: 1,
                textTransform: 'none',
                fontWeight: 600,
                minWidth: '100px'
              }}
            >
              {disableActions ? 'Carregando...' : 'Filtrar'}
            </Button>
            
            <Button
              variant="outlined"
              color="secondary"
              size="small"
              onClick={handleClearClick}
              disabled={disableActions}
              startIcon={<RefreshIcon />}
              sx={{ 
                flexShrink: 0,
                height: 40,
                borderRadius: 1,
                textTransform: 'none',
                fontWeight: 600
              }}
            >
              Limpar
            </Button>
          </Box>
        </Box>
      </Box>
      
      <Divider sx={{ mb: 2 }} />
      
      <Box sx={{ 
        display: "flex", 
        flexDirection: "column",
        justifyContent: "center", 
        alignItems: "center", 
        height: "220px",
        gap: 2
      }}>        <Box sx={{ 
          width: 80,
          height: 80,
          borderRadius: '50%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#e3f2fd',
          color: '#1565c0',
          mb: 2
        }}>
          {disableActions ? 
            <CircularProgress size={40} /> : 
            <SearchIcon sx={{ fontSize: 40 }} />
          }
        </Box><Typography variant="body1" color="text.secondary" sx={{ textAlign: 'center', maxWidth: 480 }}>
          {disableActions ? 
            "Carregando dados do produto... Aguarde enquanto processamos as informações do ciclo de vida." : 
            "Gráfico de evolução será exibido quando você filtrar por um SKU específico. Acompanhe tendências de vendas ao longo do tempo para tomar decisões estratégicas sobre estoque e promoções."
          }
        </Typography>
      </Box>
    </Paper>
  );
}
